import { createContext } from 'react'
import { AppConfigContextType } from '../types/app-config-context-type'
import dayjs from 'dayjs'

const sevenDaysAgo = dayjs(dayjs()).subtract(7, 'days')
const defaultDateRange = {
    startDate: dayjs(sevenDaysAgo).format('l'),
    endDate: dayjs().format('l'),
}

export const AppConfigContext = createContext<AppConfigContextType>({
    language: '',
    timezone: '',
    units: '',
    userData: {},
    assetEmailNotification: false,
    geofenceEmailNotification: false,
    inAppNotification: false,
    notificationDateRange: defaultDateRange,
    setNotificationDateRange: () => {},
    setAssetEmailNotification: () => {},
    setGeofenceEmailNotification: () => {},
    setInAppNotification: () => {},
    setLanguage: () => {},
    setTimezone: () => {},
    setUnits: () => {},
    setUserData: () => {},
})
